import { EventId, NameIdPairDto } from './IEvent'

export type AlertId = string

export enum AlertSendType {
  Immediate = 'Immediate',
  Scheduled = 'Scheduled',
}

export enum CommunicationChannel {
  Email = 'Email',
  Sms = 'Sms',
}

export enum AlertCategoryType {
  GenericAlert = 'GenericAlert',
  CustomerAlert = 'CustomerAlert',
  StakeholderAlert = 'StakeholderAlert',
}

export enum TemplateLanguage {
  Norwegian = 'Norwegian',
  English = 'English',
}

export interface AlertTemplate {
  id: number
  title: string
  subject: string
  editedSubject: string
  text: string
  editedText: string
  channel?: CommunicationChannel
  editableFields: Dictionary<Date | string>
  sender: string
  customerInformationNeeded: boolean
  language?: TemplateLanguage
  templateKey?: string
}

export interface AlertDto {
  id: AlertId
  eventId: EventId
  channel: CommunicationChannel | undefined
  category: AlertCategoryType | undefined
  type: AlertSendType | undefined
  template: AlertTemplate
  englishTemplate?: AlertTemplate
  description: string
  isSent: boolean
  sendOn: Date
  phoneNumbers: string[]
  emailAddresses: string[]
  createdOn: Date
  createdBy: NameIdPairDto
  notifiedCustomers: NotifiedCustomers
  notifiedCustomersCount: number
  lastChangedBy: NameIdPairDto
  lastChangedOn: Date
  sendResult: AlertSendResult
  status: AlertSendStatus
}

export interface AlertSendResult {
  totalNumberOfRecipients: number
  numberOfDelivered: number
  numberOfFailed: number
  failedRecipients: FailedRecipient[]
}

export enum AlertSendStatus {
  NotProcessed = 'NotProcessed',
  Processing = 'Processing',
  Sent = 'Sent',
  SentPartially = 'SentPartially',
  FailedBeforeSend = 'FailedBeforeSend',
  Draft = 'Draft',
}

export interface FailedRecipient {
  emailStatus?: EmailStatus
  smsStatus?: SmsStatus
}

export interface EmailStatus {
  recipient: string
  emailSendStatus: EmailSendStatus
}

export enum EmailSendStatus {
  SentOk = 1,
  Error = 2,
  NotSentRecipientNotWhitelisted = 3,
  Undefined = 99,
}

export interface SmsStatus {
  recipient: string
  statusCode: SmsStatusCode
}

export enum SmsStatusCode {
  MessageDeliveredOk = 1,
  AccessError,
  IllegalAction,
  IllegalService,
  SyntaxError,
  InternalError,
  NumberWasNotWhiteListed,
  NotSent,
  NoResponse,
  FailedInEbLibrary,
  EmptyContent,
}

export interface NotifiedCustomers {
  allCompanyCustomers: boolean
  companyCustomerIds: string[]
  companyWithSlaCustomerIds: string[]
  privateCustomerIds: string[]
  phoneNumbers?: string[]
  emailAddresses?: string[]
}

export interface Dictionary<T> {
  [Key: string]: T
}

export interface AlertStatus {
  id: string
  doneProcessing: boolean
  state: string
  failureMessage: string | null
  processingAttempts: number
  recipient: Recipient[]
  lastProcessedAt: string
}

export interface Recipient {
  id: string
  displayName: string
  lastSendAttempt: string
  result: string
  message: string | null
  channelUsed: string
}

export interface AlertInstance {
  id: string
  doneProcessing: boolean
  state: string
  failureMessage: string | null
  processingAttempts: number
  recipient: Recipient[]
  lastProcessedAt: string
}
